import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './404/404.component';
import { ErrorComponent } from './error.component';
import { UnauthorizedComponent } from './401/401.component';
import { ForbiddenComponent } from './403/403.component';
import { InternalErrorComponent } from './500/500.component';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', redirectTo: '/home', pathMatch: 'full', },
      { path: '401', component:UnauthorizedComponent, data: {title:'Acesso negado', isError:true} },
      { path: '403', component:ForbiddenComponent, data: {title:'Proibido', isError:true} },
      { path: '404', component:NotFoundComponent, data: {title:'Página não encontrada', isError:true} },
      { path: '500', component:InternalErrorComponent, data: {title:'Erro interno', isError:true} }
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class ErrorRoutingModule {}

